import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_OFFICE + name;
};

export let PathnameOffice = {
  LANDING_PAGE: "/",
  LIST: "/list",
};
